import {Injectable} from '@angular/core';
import {DataCoreService} from '@dabnet-kamu/libs/ui';
import {TebKurumSinifService} from '../ctl-teb-kurum-sinif.service';

@Injectable()
export class Service {

  constructor(private dataCoreService: DataCoreService, private service: TebKurumSinifService) {
  }

  getData(control: any, modul?: string, tur: string = 'Y') {
    let tableName = control.dlistMetadata.baseEntity;
    const queryParams: string[] = [];

    // Modul varsa ekle
    if (modul?.length > 0) {
      queryParams.push(`Modul=${modul}`);
    }

    // Tur parametresi (default = Y)
    if (tur?.length > 0) {
      queryParams.push(`Tur=${tur}`);
    }

    // Donem parametresi (service.period varsa)
    if (this.service.period) {
      queryParams.push(`Donem=${this.service.period}`);
    }

    // Query string birleştir
    if (queryParams.length > 0) {
      tableName = `${tableName}?${queryParams.join('&')}`;
    }

    const dataSource = this.dataCoreService.getOData(tableName);

    dataSource.select([
      'Kod',
      'Ad',
      'Donem',
      'KurumsalKod',
    ]);
    // Filter (Donem ve KurumsalKod koşulları)
    const filterArr: any[] = [];
    filterArr.push(['KurumsalKod.Length', '>=', 8]);
    dataSource.filter(filterArr);

    return dataSource;
  }

}
